import axios from 'axios'
import { set } from 'vue'

// Initial state factory function
const getDefaultState = () => {
  return {
    lineGroup: {
      isLoaded: false,
      list: []
    },
    huntList: {
      isLoaded: false,
      list: []
    },
    huntPilot: {
      isLoaded: false,
      list: []
    },
    routePartition: {
      isLoaded: false,
      list: []
    },
    callPickupGroup: {
      isLoaded: false,
      list: []
    },
    translationPattern: {
      isLoaded: false,
      list: []
    },
    callingSearchSpace: {
      isLoaded: false,
      list: []
    }
  }
}

export default {
  state: getDefaultState(),
  getters: {
    cucmGroupList: (state) => (groupName) => state[groupName]?.list
  },
  mutations: {
    SET_CUCM_GROUP_LIST(state, { groupName, list }) {
      set(state[groupName], 'list', list)
      set(state[groupName], 'isLoaded', true)
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getCucmGroup({ state, commit }, { groupName, forceLoad = false }) {
      if (state[groupName].isLoaded && forceLoad === false) return

      const res = await axios.get(`/cucm/${groupName}/list`)

      commit('SET_CUCM_GROUP_LIST', {
        groupName,
        list: res.data.map((item) => {
          if (groupName === 'translationPattern') {
            return {
              name: item.pattern,
              routePartitionName: item.routePartitionName || null
            }
          }

          return {
            name: item
          }
        })
      })
    },
    async getAllCucmGroups({ dispatch }) {
      const groupNames = [
        'lineGroup',
        'huntList',
        'huntPilot',
        'routePartition',
        'callPickupGroup',
        'translationPattern',
        'callingSearchSpace'
      ]

      await Promise.all(
        groupNames.map((groupName) =>
          dispatch('getCucmGroup', { groupName, forceLoad: true })
        )
      )
    },
    async addCucmGroupList({ dispatch }, { groupName, form }) {
      console.log(groupName, form)

      let params = { ...form }

      if (groupName === 'translationPattern') {
        params = {
          name: form.pattern,
          routePartition: form.routePartition || null
        }
      }

      const res = await axios({
        method: 'post',
        url: `/cucm/${groupName}/create`,
        params: params,
        paramsSerializer: (params) => {
          // Properly URL-encode all parameter values including special chars like []
          return Object.keys(params)
            .map((key) => {
              const value = params[key]
              if (value === null || value === undefined) {
                return null
              }
              return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            })
            .filter((param) => param !== null)
            .join('&')
        }
      })
      dispatch('getCucmGroup', { groupName, forceLoad: true })
      return res.status
    }
    // async editLineGroup({ dispatch }, { id, data }) {
    //   const res = await axios.put(`/lineGroup/${id}`, data)
    //   dispatch('getLineGroup')
    //   return res.status
    // }
  }
}
